import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

export const GcpWifComponents = InstallSpec({
  identity: ItemComponent({
    label: "Workload Identity Federation",
    description:
      "Allows P0 to grant and revoke GCP access for OIDC-authenticated agents (e.g. CI/CD pipelines). Requires the Google Cloud integration to be installed for the same project.",
    type: "string",
    maturity: "preview",
    schema: {
      projectId: Element({
        label: "GCP project ID",
        type: "dynamic",
        step: "new",
      }),
      // We take the OIDC provider URL here and use it to generate gcloud
      // CLI/Terraform instructions for creating the Workload Identity Pool + provider --
      // rather than requiring the customer to set it up beforehand. The pool/provider IDs
      // themselves are deterministically derived from the install name (see naming.ts),
      // matching the approach aws-oidc takes for its pool role names.
      oidcProviderUrl: Element({
        label: "OIDC provider URL",
        description:
          "Issuer URL of your OIDC provider (e.g. https://token.actions.githubusercontent.com)",
        type: "string",
        step: "new",
        validator: async (_id, field) => {
          try {
            new URL(field);
          } catch {
            return "OIDC provider URL must be a valid URL";
          }
        },
      }),
      // Not customer-entered: GCP's default provider audience (its own full
      // resource name) is used instead of a custom allowed_audiences value
      // (see terraform.ts) -- this is computed by the backend at install
      // time (see gcp-wif's install assembler) once projectId is known.
      audience: Element({
        label: "Audience",
        description:
          "The aud claim the identity will send to GCP when calling APIs",
        type: "generated",
      }),
    },
  }),
});
